module.exports = __webpack_public_path__ + "static/burning_hands-b91f5215d922cfcd76c814e05a21d148.jpg";